module.exports = __webpack_public_path__ + "static/media/wedding02.7de11489.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/wedding02.jpg
// module id = 422
// module chunks = 0